import { USState } from './USState';
import { USTerritory } from './USTerritory';
import { USMilitaryState } from './USMilitaryState';

export const USProvince = { ...USState, ...USTerritory, ...USMilitaryState };

/**
 * Describes any valid US state, territory, or military address as a
 * [USPS Postal Code](https://pe.usps.com/text/pub28/28apb.htm).
 */
export type USProvince = USState | USTerritory | USMilitaryState;
